<template>
  <table class="table table-condensed">
    <thead>
      <tr>
        <th class="col-xs-5">
          {{ trans('core.type') }}
        </th>
        <th class="col-xs-5">
          {{ trans('core.progress') }}
        </th>
        <th class="col-xs-2">
          {{ trans('core.achieved') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <template v-for="rule in rules">
        <colloquium-rule :rule="rule" />
      </template>
    </tbody>
    <tfoot>
      <template v-if="hasTotal">
        <colloquium-rule
          :rule="calculateTotalRule"
          :is-total="true"
        />
      </template>
    </tfoot>
  </table>
</template>

<script>
import ColloquiumRule from './ColloquiumRule'

export default {
  name: 'ColloquiumRules',
  components: { ColloquiumRule },
  props: {
    rules: { required: true },
    total: { default: 0 },
  },
  data () {
    return { rule: [] }
  },
  computed: {

    hasTotal () {
      return this.total > 0
    },

    // Create a rule to show the total
    calculateTotalRule () {
      var points = 0
      for (let i in this.rules) {
        points += this.getPoints(this.rules[i])
      }

      Vue.set(this.rule, 'min', this.total)
      // Max is always zero, since there is no maximum.
      Vue.set(this.rule, 'max', 0)
      Vue.set(this.rule, 'student_points', points)
      Vue.set(this.rule, 'type', Lang.trans('core.total_points'))

      return this.rule
    },

  },
  methods: {
    getPoints (rule) {
      if (rule.max != 0) {
        return Math.min(rule.max, rule.student_points)
      }
      return rule.student_points
    },
  },

}
</script>

<style scoped>

</style>
